@if (avatars | fn: getAvatarGroup; as avatarGroup) {
    @if (avatarGroup?.length > 1 || forceGroup) {
        <div
            class="avatar-group avatar-group-{{
                size
            }} d-flex align-items-center"
            [class.fixed-width]="fixedWidth"
        >
            @for (avatar of avatarGroup; track $index; let i = $index) {
                @if (i < limit - 1 || avatarGroup.length === limit) {
                    <molecule-avatar
                        class="avatar-group-avatar rounded-circle pointer"
                        [class.on-muted-bg]="onMutedBg"
                        [class.on-active-bg]="onActiveBg"
                        [style.z-index]="limit - i"
                        [avatar]="avatar"
                        [size]="size"
                        [isAvatarInfoEnabled]="avatar?.isAvatarInfoEnabled"
                    ></molecule-avatar>
                }
            }
            @if (
                avatarGroup | fn: getOverflowAvatarsMenu : limit;
                as overflowAvatarsMenu
            ) {
                <div ngbDropdown container="body" class="z-index-0">
                    <button
                        ngbDropdownToggle
                        class="btn btn-icon avatar avatar-{{
                            size
                        }} bg-icon border-transparent z-index-0 position-relative"
                        (click)="$event.stopPropagation()"
                    >
                        <span class="avatar-alt-initials"
                            >+{{ avatarGroup.length - limit + 1 }}</span
                        >
                    </button>
                    <molecule-context-menu
                        ngbDropdownMenu
                        [menu]="overflowAvatarsMenu"
                    ></molecule-context-menu>
                </div>
                <div class="z-index-0">
                    @for (
                        overflowAvatar of overflowAvatarsMenu;
                        track $index
                    ) {
                        <atom-modal-wrapper
                            [modalId]="overflowAvatar.modalId"
                            [modalTemplate]="avatarInfoModal"
                        >
                            <ng-template #avatarInfoModal>
                                <organism-modal modalTitle="Avatar Information">
                                    <molecule-avatar-info
                                        [avatar]="overflowAvatar.avatar"
                                        [editModalId]="editModalId"
                                    ></molecule-avatar-info>
                                </organism-modal>
                            </ng-template>
                        </atom-modal-wrapper>
                    }
                </div>
            }
        </div>
    } @else {
        <molecule-avatar
            class="avatar-single pointer avatar-group-border-transparent"
            [avatar]="avatars[0]"
            [size]="size"
            [isAvatarInfoEnabled]="avatars[0]?.isAvatarInfoEnabled"
            [editModalId]="editModalId"
        ></molecule-avatar>
    }
}
